/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../Redux/Store';
import { AppContext } from '../../Context/AppContext';
import { useAppDispatch, useAppSelector } from '../../Hooks/Hooks';
import {
  getSearchLoads,
  getUserWatchedLoads,
  handleResetPaginationFilter,
  handleResetToggleFilter,
  updateLoadByIdData,
  updateSearchResultData,
  updateSortAndFilter,
  updateUserWatchedLoads,
} from '../../Redux/Reducers/SearchSlice';
import { getLoadData } from '../../Redux/Reducers/MyLoadsSlice';
import {
  ANYWHERE,
  COOKIE_IDS,
  KEYS,
  MY_LOADS_PAGINATION,
  SERVER_ERROR_MESSAGES,
  WATCHED_LOAD_ADDED,
  WATCHED_LOAD_REMOVED,
} from '../../Constants/Constants';
import { dataBaseFriendlyDateFormat } from '../../Utils/DateUtils';
import { isEmptyObject, scrollIntoView } from '../../Utils/Basic';
import {
  getSoloTeamType,
  filterStopAppointments,
  deadHeadValidation,
  hasDeadHeadValue,
} from '../../Utils/Search';
import { EVENT, SCREEN, TAB } from '../../Constants/AnalyticsConstants';
import { getCookie, deleteCookie } from '../../Utils/CookieUtils';
import { fbLogEvent } from '../../Helpers/FirebaseHelper';
import { sortTypeOptions } from '../Search/NewSearchContainer/NewSearchContainer.type';
import { TResultContainerProps } from './ResultContainer.type';
import { ELoadCardSize } from '../Shared/LoadCard/LoadCard.type';
import LoadCard from '../Shared/LoadCard/LoadCard';
import ShowMoreButton from '../Shared/ShowMoreButton/ShowMoreButton';
import SortingContainer from '../Shared/SortingContainer/SortingContainer';
import ToggleSearchButton from '../Shared/ToggleSearchButton/ToggleSearchButton';
import NoResults from '../Search/NoResults/NoResults';
import './ResultContainer.scss';

export const MocklistAndMapData = [
  {
    slug: 'list',
    title: 'List',
    imgSrc: '/oo/assets/icon/list-icon.svg',
    selected: true,
    visible: false,
  },
  {
    slug: 'map',
    title: 'Map',
    imgSrc: '/oo/assets/icon/map-icon.svg',
    selected: false,
    visible: false,
  },
];

const ResultContainer = (props: TResultContainerProps) => {
  const {
    totalRecords = 0,
    loadPostings = [],
    additionalClass,
    label = 'Results',
    isWatchedLoads = false,
    isFavorite = false,
    isStateSelectionEnabled,
    isNewSearch,
    isRecent,
    isMatchedLoadsHome,
    isMyLoads = false,
    isRecentlyDelivered = false,
  } = props;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isMobile } = useContext(AppContext);
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const { searchQuery, sortAndFilter, loadByIdData, resetToggleFilter, searchResultData } =
    useAppSelector((state: RootState) => state.search);
  const { myLoadsSortAndFilter } = useAppSelector((state: RootState) => state.myLoads);
  const [confirmedAppointments, setConfirmedAppointments] = useState(false);
  const [standardNetwork, setStandardNetwork] = useState(false);
  const [loads, setConfirmedLoads] = useState(loadPostings);
  const [renderLoadById, setRenderLoadById] = useState(false);
  const hasStandardNetwork = useRef(false);
  const hasConfirmedAppointment = useRef(false);
  const showStandardNetwork =
    memberData?.member?.userApplicationDetails[0]?.attributes?.ExtendedNetwork === 'true';

  useEffect(() => {
    if (resetToggleFilter) {
      if (confirmedAppointments) {
        setConfirmedAppointments(false);
        hasConfirmedAppointment.current = false;
      }
      if (standardNetwork) {
        hasStandardNetwork.current = false;
        setStandardNetwork(false);
      }
      dispatch(handleResetToggleFilter(false));
    }
  }, [resetToggleFilter]);
  useEffect(() => {
    setConfirmedLoads(loadPostings);
  }, [loadPostings]);
  const tabFinding = () => {
    if (props?.isRecent) {
      return TAB.RECENT;
    } else if (props?.isNewSearch) {
      return TAB.NEW;
    } else if (props?.isFavorite) {
      return TAB.FAVORITE;
    } else if (props?.isWatchedLoads) {
      return TAB.WATCHED;
    }
  };

  const handleNewSearch = (_sortAndFilter?: any) => {
    const payload = {
      size: _sortAndFilter ? _sortAndFilter?.size : sortAndFilter?.size,
      page: _sortAndFilter ? _sortAndFilter?.page : sortAndFilter?.page,
      sortColumn: _sortAndFilter ? _sortAndFilter?.sortColumn : sortAndFilter?.sortColumn,
      sortDirection: _sortAndFilter ? _sortAndFilter?.sortDirection : sortAndFilter?.sortDirection,
      originCity: searchQuery?.originLocation?.City ?? ANYWHERE,
      originState: searchQuery?.originLocation?.State ?? '',
      originRadius: searchQuery?.originRadius,
      originCountry: searchQuery?.originLocation?.Country ?? 'US',
      originPostalCode: searchQuery?.originLocation?.Zip ?? '',
      pickUpStartDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.originFromDate,
          'startDate',
          searchQuery?.originLocation?.TimeZone || 'GMT',
        ) ?? '',
      pickUpEndDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.originToDate,
          'endDate',
          searchQuery?.originLocation?.TimeZone || 'GMT',
        ) ?? '',
      dropStartDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.destinationFromDate,
          'startDate',
          searchQuery?.destinationLocation?.TimeZone || 'GMT',
        ) ?? '',
      dropEndDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.destinationToDate,
          'endDate',
          searchQuery?.destinationLocation?.TimeZone || 'GMT',
        ) ?? '',
      destinationCity: !isStateSelectionEnabled
        ? (searchQuery?.destinationLocation?.City ?? ANYWHERE)
        : '',
      destinationStates:
        isStateSelectionEnabled || !searchQuery?.destinationLocation?.City
          ? searchQuery?.destinationLocation?.State?.filter(
              (item?: any) => !isEmptyObject(item),
            ).map((item: any) => item?.code)
          : searchQuery?.destinationLocation?.State
            ? [searchQuery?.destinationLocation?.State]
            : [],
      destinationCountry: searchQuery?.destinationLocation?.Country ?? '',
      destinationPostalCode: searchQuery?.destinationLocation?.Zip ?? '',
      destinationRadius: searchQuery?.destinationRadius,
      excludeSpecialServices: searchQuery?.excludeSpecialServices,
      maxMiles: searchQuery?.maxMiles,
      minMiles: searchQuery?.minMiles,
      minRPM: searchQuery?.minRPM,
      appointmentConfirmed: confirmedAppointments ? true : null,
      extendedNetwork: standardNetwork ? false : null,
    };
    if (
      !(
        isEmptyObject(searchQuery?.originLocation) &&
        (isEmptyObject(searchQuery?.destinationLocation) ??
          (isStateSelectionEnabled &&
            !searchQuery?.destinationLocation?.State?.filter((item: any) => !isEmptyObject(item))
              ?.length))
      ) &&
      !(isWatchedLoads || isMatchedLoadsHome)
    )
      dispatch(getSearchLoads({ queryPayloads: payload }));
    else if (isWatchedLoads || isMatchedLoadsHome) {
      const queryPayloads = {
        size: _sortAndFilter ? _sortAndFilter?.size : sortAndFilter?.size,
        page: _sortAndFilter ? _sortAndFilter?.page : sortAndFilter?.page,
        sortColumn: _sortAndFilter ? _sortAndFilter?.sortColumn : sortAndFilter?.sortColumn,
        sortDirection: _sortAndFilter
          ? _sortAndFilter?.sortDirection
          : sortAndFilter?.sortDirection,
        carrierId:
          memberData?.member?.userApplicationDetails?.[0].attributes.CommonCarrierId ?? null,
        userId: memberData?.member?.upn ?? null,
        favorite: true,
        managedEquipmentCapability: 'Buy Load',
        nonManagedEquipmentCapability: 'Buy Load',
        userRole: memberData?.member?.userApplicationDetails?.[0]?.roles
          ?.map((item: any) => item?.roleName)
          ?.join(','),
        siteId: 'FPO',
        appointmentConfirmed: confirmedAppointments ? true : null,
        extendedNetwork: standardNetwork ? false : null,
      };
      dispatch(getUserWatchedLoads(queryPayloads));
    }
  };
  const handleFetchUserWatchedLoads = useCallback(() => {
    if (isWatchedLoads) {
      const queryPayloads = {
        carrierId:
          memberData?.member?.userApplicationDetails?.[0].attributes.CommonCarrierId ?? null,
        userId: memberData?.member?.upn ?? null,
        favorite: true,
        managedEquipmentCapability: 'Buy Load',
        nonManagedEquipmentCapability: 'Buy Load',
        userRole: memberData?.member?.userApplicationDetails?.[0]?.roles
          ?.map((item: any) => item?.roleName)
          ?.join(','),
        siteId: 'FPO',
        ...sortAndFilter,
      };
      if (memberData?.member?.upn) {
        dispatch(getUserWatchedLoads(queryPayloads));
      }
    }
  }, [isWatchedLoads, memberData?.member?.upn, sortAndFilter?.page]);

  useEffect(() => {
    handleFetchUserWatchedLoads();
  }, [handleFetchUserWatchedLoads]);

  useEffect(() => {
    if (!isEmptyObject(loadByIdData)) {
      setRenderLoadById(true);
    }
  }, [loadByIdData]);

  useEffect(() => {
    const loadId = getCookie(COOKIE_IDS.SHIPMENT_ID);
    if (loadId) {
      scrollIntoView(loadId);
      deleteCookie(COOKIE_IDS.SHIPMENT_ID);
    }
  }, []);

  const matchValue = !isEmptyObject(loadByIdData) ? 1 : null;

  const getOriginStop = (loads: any[]) => {
    return !!loads?.length
      ? loads?.map((load) => {
          const loadStop = load.loadStop || load.shipmentStops;
          const stop = loadStop.find((item: any) => item.stopSequence === 1);
          return deadHeadValidation(stop?.deadHead);
        })
      : [];
  };

  const getDestinationStop = (loads: any[]) => {
    return !!loads?.length
      ? loads?.map((load) => {
          const loadStop = load.loadStop || load.shipmentStops;
          const stop = loadStop.find((item: any) => item.stopSequence === load.numberOfStops);
          return deadHeadValidation(stop?.deadHead);
        })
      : [];
  };

  const stopInfoOrigin = getOriginStop(loads);
  const stopInfoDestination = getDestinationStop(loads);

  const filteredSortTypeOptions = sortTypeOptions.map((option) => {
    if (
      (isEmptyObject(searchQuery.originLocation) ||
        searchQuery.originLocation.City === 'Anywhere' ||
        !hasDeadHeadValue(stopInfoOrigin)) &&
      option.slug === 'originDeadHead'
    ) {
      return { ...option, hide: true };
    }
    if (
      (isEmptyObject(searchQuery.destinationLocation) ||
        searchQuery.destinationLocation.City === 'Anywhere' ||
        !hasDeadHeadValue(stopInfoDestination)) &&
      option.slug === 'destinationDeadHead'
    ) {
      return { ...option, hide: true };
    }
    if (isWatchedLoads && option?.slug === 'EstTotalRPM') {
      return { ...option, hide: true };
    }
    if (!(searchQuery?.originLocation?.State?.length > 0) && option?.slug === 'EstTotalRPM') {
      return { ...option, hide: true };
    }
    return option;
  });

  const handleShowMore = () => {
    dispatch(
      updateSortAndFilter({
        ...sortAndFilter,
        page: sortAndFilter?.page + 1,
      }),
    );
    return handleNewSearch({
      ...sortAndFilter,
      page: sortAndFilter?.page + 1,
    });
  };
  const handleSortDirectionChange = () => {
    dispatch(
      updateSortAndFilter({
        ...sortAndFilter,
        sortDirection: sortAndFilter.sortDirection === 'asc' ? 'dsc' : 'asc',
        page: 0,
      }),
    );
    return handleNewSearch({
      ...sortAndFilter,
      sortDirection: sortAndFilter.sortDirection === 'asc' ? 'dsc' : 'asc',
      page: 0,
    });
  };
  const handleRightTopButtonClick = (id: string) => {
    const load =
      (loadPostings?.length && loadPostings?.find((item: any) => item?.loadId === id)) ||
      loadByIdData;

    const queryPayloads = {
      operation: load?.isWatched ? 'DELETE' : 'ADD',
      loadId: load?.loadId,
      watchDate: dayjs().toISOString(),
      origin: '',
      carrierId: memberData?.member?.userApplicationDetails?.[0].attributes.CommonCarrierId ?? null,
      userId: memberData?.member?.upn ?? null,
      siteId: 'FPO',
    };
    const callback = (res: any) => {
      if (res?.postingStatus === 'Success') {
        toast(load?.isWatched ? WATCHED_LOAD_REMOVED : WATCHED_LOAD_ADDED);
        if (isWatchedLoads) {
          handleFetchUserWatchedLoads();
          handleResetPaginationFilter();
        } else if (loadByIdData) {
          dispatch(updateLoadByIdData({ ...load, isWatched: !load?.isWatched }));
        } else {
          dispatch(
            updateSearchResultData({
              ...searchResultData,
              loadPostings: searchResultData?.loadPostings?.map((item: any) => {
                if (item?.loadId === load?.loadId) {
                  return { ...item, isWatched: !load?.isWatched };
                }
                return item;
              }),
            }),
          );
        }
      } else {
        toast(res?.errorMessage ?? SERVER_ERROR_MESSAGES?.generalMsg);
      }
    };
    dispatch(updateUserWatchedLoads({ queryPayloads, callback }));
    fbLogEvent(load?.isWatched ? EVENT.UE_MARK_UNWATCH : EVENT.UE_MARK_WATCH, {
      screen: SCREEN.SEARCH,
      tab: isWatchedLoads ? TAB.WATCHED : TAB.NEW,
      origin: [
        load?.loadStop[1].city || load?.shipmentStops[1].city,
        load?.loadStop[1].state || load?.shipmentStops[1].state,
      ],
      destination: [
        load?.loadStop[0].city || load?.shipmentStops[0].city,
        load?.loadStop[0].state || load?.shipmentStops[0].state,
      ],
      loadId: load?.loadId,
      ...(load?.division && { load_divison: load?.division }),
      ...(load?.rate?.binSources && { load_source_tms: load?.rate?.binSource }),
      ...(load?.rate?.binRateIdentifier && { load_bin_rate_id: load?.rate?.binRateIdentifier }),
      ...(load?.estimatedTotalRpm && { load_estimated_rpm: load?.estimatedTotalRpm }),
    });
  };
  const handleClick = (id?: string) => {
    if (props?.isMyLoads) {
      dispatch(getLoadData({ id })).then(() => {
        id && navigate(`/expanded/${'myloads'}/${id}`);
      });
    } else {
      tabFinding();
      id && navigate(`/expanded/${tabFinding()}/${id}`);
    }
  };
  const handleConfirmedApptToggle = () => {
    const payload = {
      size: sortAndFilter?.size,
      page: 0,
      sortColumn: sortAndFilter?.sortColumn,
      sortDirection: sortAndFilter?.sortDirection,
      originCity: searchQuery?.originLocation?.City ?? ANYWHERE,
      originState: searchQuery?.originLocation?.State ?? '',
      originRadius: searchQuery?.originRadius,
      originCountry: searchQuery?.originLocation?.Country ?? 'US',
      originPostalCode: searchQuery?.originLocation?.Zip ?? '',
      pickUpStartDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.originFromDate,
          'startDate',
          searchQuery?.originLocation?.TimeZone || 'GMT',
        ) ?? '',
      pickUpEndDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.originToDate,
          'endDate',
          searchQuery?.originLocation?.TimeZone || 'GMT',
        ) ?? '',
      dropStartDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.destinationFromDate,
          'startDate',
          searchQuery?.destinationLocation?.TimeZone || 'GMT',
        ) ?? '',
      dropEndDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.destinationToDate,
          'endDate',
          searchQuery?.destinationLocation?.TimeZone || 'GMT',
        ) ?? '',
      destinationCity: !isStateSelectionEnabled
        ? (searchQuery?.destinationLocation?.City ?? ANYWHERE)
        : '',
      destinationStates:
        isStateSelectionEnabled || !searchQuery?.destinationLocation?.City
          ? searchQuery?.destinationLocation?.State?.filter(
              (item?: any) => !isEmptyObject(item),
            ).map((item: any) => item?.code)
          : searchQuery?.destinationLocation?.State
            ? [searchQuery?.destinationLocation?.State]
            : [],
      destinationCountry: searchQuery?.destinationLocation?.Country ?? '',
      destinationPostalCode: searchQuery?.destinationLocation?.Zip ?? '',
      destinationRadius: searchQuery?.destinationRadius,
      excludeSpecialServices: searchQuery?.excludeSpecialServices,
      maxMiles: searchQuery?.maxMiles,
      minMiles: searchQuery?.minMiles,
      minRPM: searchQuery?.minRPM,
      appointmentConfirmed: confirmedAppointments ? true : null,
      extendedNetwork: standardNetwork ? false : null,
    };
    const queryPayloads = {
      carrierId: memberData?.member?.userApplicationDetails?.[0].attributes.CommonCarrierId ?? null,
      userId: memberData?.member?.upn ?? null,
      favorite: true,
      managedEquipmentCapability: 'Buy Load',
      nonManagedEquipmentCapability: 'Buy Load',
      userRole: memberData?.member?.userApplicationDetails?.[0]?.roles
        ?.map((item: any) => item?.roleName)
        ?.join(','),
      siteId: 'FPO',
      ...sortAndFilter,
      appointmentConfirmed: confirmedAppointments ? true : null,
      extendedNetwork: standardNetwork ? false : null,
    };
    dispatch(handleResetPaginationFilter());
    if (isWatchedLoads || isMatchedLoadsHome) {
      dispatch(getUserWatchedLoads(queryPayloads));
    } else {
      dispatch(getSearchLoads({ queryPayloads: payload }));
    }
  };
  useEffect(() => {
    if (hasConfirmedAppointment.current) {
      handleConfirmedApptToggle();
    } else {
      hasConfirmedAppointment.current = true;
    }
  }, [confirmedAppointments]);
  const ToggleComponent = () => {
    return (
      <div className="Toggle_Container">
        <span>Confirmed Appointments Only</span>
        <ToggleSearchButton
          onToggle={() => {
            setConfirmedAppointments(!confirmedAppointments);
            fbLogEvent(EVENT.UE_CONFIRMED_APPOINTMENTS_SWITCH, {
              screen: SCREEN.SEARCH,
              tab: tabFinding(),
              mode: confirmedAppointments === false ? 'on' : 'off',
            });
          }}
          value={confirmedAppointments}
          disabled={!(loads?.length > 0) && !confirmedAppointments}
        />
      </div>
    );
  };
  const handleStandardNetworkToggle = () => {
    const payload = {
      size: sortAndFilter?.size,
      page: 0,
      sortColumn: sortAndFilter?.sortColumn,
      sortDirection: sortAndFilter?.sortDirection,
      originCity: searchQuery?.originLocation?.City ?? ANYWHERE,
      originState: searchQuery?.originLocation?.State ?? '',
      originRadius: searchQuery?.originRadius,
      originCountry: searchQuery?.originLocation?.Country ?? 'US',
      originPostalCode: searchQuery?.originLocation?.Zip ?? '',
      pickUpStartDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.originFromDate,
          'startDate',
          searchQuery?.originLocation?.TimeZone || 'GMT',
        ) ?? '',
      pickUpEndDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.originToDate,
          'endDate',
          searchQuery?.originLocation?.TimeZone || 'GMT',
        ) ?? '',
      dropStartDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.destinationFromDate,
          'startDate',
          searchQuery?.destinationLocation?.TimeZone || 'GMT',
        ) ?? '',
      dropEndDate:
        dataBaseFriendlyDateFormat(
          searchQuery?.destinationToDate,
          'endDate',
          searchQuery?.destinationLocation?.TimeZone || 'GMT',
        ) ?? '',
      destinationCity: !isStateSelectionEnabled
        ? (searchQuery?.destinationLocation?.City ?? ANYWHERE)
        : '',
      destinationStates:
        isStateSelectionEnabled || !searchQuery?.destinationLocation?.City
          ? searchQuery?.destinationLocation?.State?.filter(
              (item?: any) => !isEmptyObject(item),
            ).map((item: any) => item?.code)
          : searchQuery?.destinationLocation?.State
            ? [searchQuery?.destinationLocation?.State]
            : [],
      destinationCountry: searchQuery?.destinationLocation?.Country ?? '',
      destinationPostalCode: searchQuery?.destinationLocation?.Zip ?? '',
      destinationRadius: searchQuery?.destinationRadius,
      excludeSpecialServices: searchQuery?.excludeSpecialServices,
      maxMiles: searchQuery?.maxMiles,
      minMiles: searchQuery?.minMiles,
      minRPM: searchQuery?.minRPM,
      extendedNetwork: standardNetwork ? false : null,
      appointmentConfirmed: confirmedAppointments ? true : null,
    };
    const queryPayloads = {
      carrierId: memberData?.member?.userApplicationDetails?.[0].attributes.CommonCarrierId ?? null,
      userId: memberData?.member?.upn ?? null,
      favorite: true,
      managedEquipmentCapability: 'Buy Load',
      nonManagedEquipmentCapability: 'Buy Load',
      userRole: memberData?.member?.userApplicationDetails?.[0]?.roles
        ?.map((item: any) => item?.roleName)
        ?.join(','),
      siteId: 'FPO',
      ...sortAndFilter,
      appointmentConfirmed: confirmedAppointments ? true : null,
      extendedNetwork: standardNetwork ? false : null,
    };
    if (isWatchedLoads || isMatchedLoadsHome) {
      dispatch(getUserWatchedLoads(queryPayloads));
    } else {
      dispatch(getSearchLoads({ queryPayloads: payload }));
    }
  };
  useEffect(() => {
    if (hasStandardNetwork.current) {
      handleStandardNetworkToggle();
    } else {
      hasStandardNetwork.current = true;
    }
  }, [standardNetwork]);
  const StandardNetworkToggleComponent = () => {
    return (
      <div className="Toggle_Container">
        <span>Standard Network Only</span>
        <ToggleSearchButton
          onToggle={() => {
            setStandardNetwork(!standardNetwork);
            fbLogEvent(EVENT.UE_STANDARD_NETWORK_SWITCH, {
              screen: SCREEN.SEARCH,
              tab: tabFinding(),
              mode: standardNetwork === false ? 'on' : 'off',
            });
          }}
          value={standardNetwork}
          disabled={!(loads?.length > 0) && !standardNetwork}
        />
      </div>
    );
  };

  return (
    <div
      className={`ResultContainer ${additionalClass}`}
      data-testid="ResultContainer"
      id="ResultContainer"
    >
      <div className="Watched_Loads_Container_Header">
        {!isMobile && (
          <div className="Watched_Loads_Container_Heading">
            <p className="Heading">{label}</p>
            {!(isMyLoads || isWatchedLoads || isMatchedLoadsHome || loadByIdData) && (
              <div className="Toggle_Component_Web">
                {showStandardNetwork && <StandardNetworkToggleComponent />}
                <ToggleComponent />
              </div>
            )}
          </div>
        )}
        {isWatchedLoads && isMatchedLoadsHome && !isMobile && (
          <div className="Watched_Loads_Text">Watched</div>
        )}
        <div className="Watched_Loads_Sort_Container">
          {/* <ListAndMapToggle data={listAndMapData} handleToggle={handleToggle} /> */}
          {!!loadPostings?.length &&
            (!isWatchedLoads ? (
              isMyLoads ? (
                <p className="Top_Padding">{totalRecords || matchValue} Assigned</p>
              ) : (
                <p>{totalRecords || matchValue} Matches</p>
              )
            ) : (
              <p>{totalRecords || matchValue} Watched Loads</p>
            ))}
          {!isEmptyObject(loadByIdData) && matchValue && <p>{matchValue} Match</p>}
          {!isMyLoads &&
            !loadByIdData &&
            (!!loadPostings?.length || !isEmptyObject(loadByIdData)) && (
              <SortingContainer
                showLabel={true}
                selectedValue={sortAndFilter?.sortColumn}
                sortDirection={sortAndFilter?.sortDirection}
                sortTypeOptions={filteredSortTypeOptions}
                handleSortDirectionChange={handleSortDirectionChange}
                handleSortType={(slug: string) => {
                  dispatch(
                    updateSortAndFilter({
                      ...sortAndFilter,
                      sortColumn: slug,
                      page: 0,
                    }),
                  );
                  return handleNewSearch({
                    ...sortAndFilter,
                    sortColumn: slug,
                    page: 0,
                  });
                }}
                modalSize="medium"
              />
            )}
        </div>
        {isMobile && !(isMyLoads || isWatchedLoads || isMatchedLoadsHome) && (
          <>
            <ToggleComponent />
            {showStandardNetwork && <StandardNetworkToggleComponent />}
          </>
        )}
      </div>
      <div>
        {!!(loads && loads?.length) ? (
          loads?.map((item: any) => (
            <LoadCard
              key={item?.loadId}
              data={item}
              isWatchedLoads={isWatchedLoads}
              showDropDown={true}
              handleRightTopButtonClick={handleRightTopButtonClick}
              handleCardClick={(id?: string) => handleClick(id)}
              showReload={true}
              showBottomButton={true}
              size={isMobile ? ELoadCardSize.small : ELoadCardSize.large}
              isSearchResults={isNewSearch || isRecent || isFavorite}
              isRecent={isRecent}
              isFavorite={isFavorite}
              isMyLoads={isMyLoads}
              isRecentlyDelivered={isRecentlyDelivered}
              showNewUpdateFlag={true}
            />
          ))
        ) : renderLoadById && !isEmptyObject(loadByIdData) ? (
          <LoadCard
            data={loadByIdData}
            isWatchedLoads={isWatchedLoads}
            handleRightTopButtonClick={handleRightTopButtonClick}
            showDropDown={true}
            showReload={true}
            showBottomButton={true}
            isSearchResults={true}
            isMyLoads={isMyLoads}
            isRecentlyDelivered={isRecentlyDelivered}
            size={ELoadCardSize.large}
            showNewUpdateFlag={true}
            isGlobalSearch={true}
          />
        ) : (
          !isMyLoads && (
            <NoResults isWatched={isWatchedLoads} isMatchedLoadsHome={isMatchedLoadsHome} />
          )
        )}
        <ShowMoreButton
          totalLoadCount={totalRecords}
          pageNumber={isMyLoads ? myLoadsSortAndFilter?.page : sortAndFilter?.page}
          perPageMaxLoadCapacity={
            isMyLoads ? MY_LOADS_PAGINATION.PAGE_SIZE : KEYS?.RESULT_PER_PAGE_MAX_LOAD_CAPACITY
          }
          handleShowMore={handleShowMore}
        />
      </div>
    </div>
  );
};
export default ResultContainer;
